 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTN3614 from '@/components/Text/N3614'
 import TEXTN3615 from '@/components/Text/N3615'
 import TEXTSECTION0001 from '@/components/Text/Section0001'
 import TEXTN3616 from '@/components/Text/N3616'
 import TEXTN3617 from '@/components/Text/N3617'
 import TEXTN3618 from '@/components/Text/N3618'
 import TEXTN3619 from '@/components/Text/N3619'
 import TEXTN3620 from '@/components/Text/N3620'
 import TEXTN3621 from '@/components/Text/N3621'
 import TEXTN3622 from '@/components/Text/N3622'
 import TEXTN3623 from '@/components/Text/N3623'
 import TEXTN3624 from '@/components/Text/N3624'
 import TEXTN3625 from '@/components/Text/N3625'
 import TEXTN3626 from '@/components/Text/N3626'
 import TEXTN3627 from '@/components/Text/N3627'
 import TEXTN3628 from '@/components/Text/N3628'
 import TEXTN3629 from '@/components/Text/N3629'
 import TEXTN3630 from '@/components/Text/N3630'
 import TEXTN3631 from '@/components/Text/N3631'
 import TEXTN3632 from '@/components/Text/N3632'
 import TEXTN3633 from '@/components/Text/N3633'
 import TEXTN3634 from '@/components/Text/N3634'
 import TEXTN3635 from '@/components/Text/N3635'
 import TEXTN3636 from '@/components/Text/N3636'
 import TEXTN3637 from '@/components/Text/N3637'
 import TEXTN3638 from '@/components/Text/N3638'
 import TEXTN3639 from '@/components/Text/N3639'
 import TEXTN3640 from '@/components/Text/N3640'
 import TEXTN3641 from '@/components/Text/N3641'
 import TEXTN3642 from '@/components/Text/N3642'
 import TEXTN3643 from '@/components/Text/N3643'
 import LOVE_2 from '@/components/love_2'
 import TEXTN3644 from '@/components/Text/N3644'
 import TEXTMOREFROM from '@/components/Text/morefrom'
 import TEXTCONNECT from '@/components/Text/connect'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/cover",
 			"name" : "Text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Text/N3614",
 			"name" : "Text/N3614",
 			"component" : TEXTN3614
 		},
 		{
 			"path" : "/Text/N3615",
 			"name" : "Text/N3615",
 			"component" : TEXTN3615
 		},
 		{
 			"path" : "/Text/Section0001",
 			"name" : "Text/Section0001",
 			"component" : TEXTSECTION0001
 		},
 		{
 			"path" : "/Text/N3616",
 			"name" : "Text/N3616",
 			"component" : TEXTN3616
 		},
 		{
 			"path" : "/Text/N3617",
 			"name" : "Text/N3617",
 			"component" : TEXTN3617
 		},
 		{
 			"path" : "/Text/N3618",
 			"name" : "Text/N3618",
 			"component" : TEXTN3618
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js